import { useMemo } from "react";
import { useApp } from "../app";
import { MIN_SELECTABLE_ENTRIES } from "./avatarConstants";
export const useAvatarPromptStyles = () => {
    const { avatarImageGeneration } = useApp();
    const promptStylesToDisplay = avatarImageGeneration.promptStyles;
    const promptStylesById = useMemo(() => {
        const byId = {};
        for (const style of promptStylesToDisplay) {
            byId[style.id] = style;
        }
        return byId;
    }, [promptStylesToDisplay]);
    const resolvedDefaultStyleId = useMemo(() => {
        const configured = avatarImageGeneration.defaultPromptStyleId;
        if (configured && promptStylesById[configured]) {
            return configured;
        }
        return promptStylesToDisplay[0]?.id ?? "";
    }, [
        promptStylesToDisplay,
        promptStylesById,
        avatarImageGeneration.defaultPromptStyleId,
    ]);
    const defaultStyle = useMemo(() => promptStylesById[resolvedDefaultStyleId], [promptStylesById, resolvedDefaultStyleId]);
    return {
        promptStylesToDisplay,
        promptStylesById,
        defaultStyleId: avatarImageGeneration.defaultPromptStyleId,
        resolvedDefaultStyleId,
        defaultStyle,
        shouldShowSelector: promptStylesToDisplay.length >= MIN_SELECTABLE_ENTRIES,
    };
};
